import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, NgModule, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { ExternalLinkDirectiveModule } from '@commons/directives/external-link/external-link.directive';

export enum CejCardResultLinkType {
  ROUTE,
  HREF,
}

export interface CejCardResultConfig {
  title: string;
  textContent?: string;
  button: {
    link: string | string[];
    text: string;
    type: CejCardResultLinkType;
    ariaLabel: string;
  };
}
@Component({
  selector: 'app-cej-result-card',
  templateUrl: './cej-result-card.component.html',
  styleUrls: ['./cej-result-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CejResultCardComponent {
  @Input() cardConfig!: CejCardResultConfig;
  @Output() tracker = new EventEmitter<void>();
  @Output() closeEvent = new EventEmitter<void>();

  CejCardResultLinkType = CejCardResultLinkType;

  trackerEvent(): void {
    this.tracker.emit();
  }

  close(): void {
    this.closeEvent.emit();
  }
}

@NgModule({
  declarations: [CejResultCardComponent],
  imports: [RouterModule, CommonModule, ExternalLinkDirectiveModule, MatIconModule],
  exports: [CejResultCardComponent],
})
export class CejResultCardModule {}
